import { render } from "./CategoryDetailed.vue?vue&type=template&id=50b6f2f6&scoped=true"
import script from "./CategoryDetailed.vue?vue&type=script&lang=js"
export * from "./CategoryDetailed.vue?vue&type=script&lang=js"

import "./CategoryDetailed.vue?vue&type=style&index=0&id=50b6f2f6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b6f2f6"]])

export default __exports__